import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useRequiredFields from "../../../../hooks/useRequiredFields";
import FormValidation from "../../../Common/FormValidation";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import ReactDropdown from "../../../Common/ReactDropdown";
import Select from "react-select";

const Create = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [error, setError] = useState({});
  const { checkRequiredFields } = useRequiredFields();

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const formSubmit = () => {
    const isValid = checkRequiredFields();
    const errors = {};

    if (!inputs.day) {
      errors.day = true;
    }

    setValidationErrors(errors);
    if (isValid && Object.keys(errors).length === 0) {
      Http.post("/weekly-off-day", inputs)
        .then((res) => {
          navigate("/weekly-off-day", {
            state: { message: res.data.message, type: "success" },
          });
        })
        .catch(function (e) {
          setError(e.response.data.errors);
        });
    }
  };

  const reactDropdownHandler = (field, prop) => (e) => {
    setInputs((values) => ({
      ...values,
      [field]: prop ? e.value[prop] : e.value,
    }));
  };

  console.log(validationErrors,"validationErrors");

  const day = [
    { value: "1", label: "Saturday" },
    { value: "2", label: "Sunday" },
    { value: "3", label: "Monday" },
    { value: "4", label: "Tuesday" },
    { value: "5", label: "Wednesday" },
    { value: "6", label: "Thursday" },
    { value: "7", label: "Friday" },
  ];

  return (
    <div>
      <IsLogin></IsLogin>
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Create Weekly Off Day</h5>
          <div className="row">
            <div className="col-lg">
              <FormValidation error={error} />
            </div>
          </div>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">
              Create Weekly Off Day Form
            </h6>
            <div className="row">
              <div className="col-lg">
                <label className="font-weight-bold">
                  Year <i className="fa fa-star required"></i>
                </label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Year"
                  name="year"
                  value={inputs.year || ""}
                  onChange={handleChange}
                  data-required
                />
              </div>
              <div className="col-lg">
                <label className="font-weight-bold">Day  <i className="fa fa-star required"></i></label>
                <div className="select">
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    name="day"
                    options={day}
                    onChange={(selectedOption) => {
                      setInputs((values) => ({
                        ...values,
                        day: selectedOption.value
                      }));
                    }}
                    styles={{
                        control: (base, state) => ({
                          ...base,
                          borderColor: validationErrors.day ? 'red' : base.borderColor,
                        })
                      }}
                  />
                </div>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-3">
                <button
                  className="btn btn-primary btn-block mg-b-10"
                  onClick={formSubmit}
                >
                  <i className="fa fa-send mg-r-10"></i> Create
                </button>
              </div>
            </div>
          </div>
          {/* card */}
        </div>
      </div>
    </div>
  );
};

export default Create;
